import { render, staticRenderFns } from "./QuoteText.vue?vue&type=template&id=6aa0f8ee&"
import script from "./QuoteText.vue?vue&type=script&lang=js&"
export * from "./QuoteText.vue?vue&type=script&lang=js&"
import style0 from "./QuoteText.vue?vue&type=style&index=0&id=6aa0f8ee&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports